import type { HasTagCondition as HasTagConditionType } from "@redotech/redo-flows-common/rules/schemas";
import { useTranslation } from "@redotech/redo-i18n";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { RuleTagPicker } from "../../rule-tag-picker";

export const HasTagCondition = memo(function HasTagCondition({
  condition,
  onChange,
  editableFields,
}: {
  condition: HasTagConditionType;
  onChange: (updated: HasTagConditionType) => void;
  editableFields?: ReadonlySet<string>;
}) {
  const { t } = useTranslation();
  const tagsEditable =
    editableFields === undefined || editableFields.has("tags");

  return (
    <Flex dir="column" gap="sm" w="full">
      <Flex
        style={
          tagsEditable ? undefined : { pointerEvents: "none", opacity: 0.6 }
        }
      >
        <RuleTagPicker
          addButtonLabel={t("Select tag")}
          onChange={(names) => {
            if (!tagsEditable) {
              return;
            }
            onChange({ ...condition, tags: names });
          }}
          selectedTagNames={condition.tags ?? []}
        />
      </Flex>
    </Flex>
  );
});
